import { ENTERPRISE, REGIONAL, SUB_REGIONAL } from "../../Enums/administratorLevels";

export class CompanyInfo {
  constructor(data) {
    this.companyId = data?.companyId ?? null;
    this.companyName = data?.companyName ?? "";
    this.adminName = data?.adminName ?? "";
    this.imagePath = data?.imagePath ?? null;
    this.companyAddress = data?.companyAddress ?? "";
    this.phone = data?.phone ?? "";
    this.phoneNumber = this.phone;
    this.email = data?.email ?? "";
    this.country = data?.country ?? "";
    this.currentPlan = data?.currentPlan ?? "";
    this.adminId = data?.adminId ?? null;
    this.billingSource = data?.billingSource ?? null;
    this.administrativeLevel = data?.administrativeLevel ?? null;
    this.administrativeId = data?.administrativeId ?? null;

    let memberSince = data?.memberSince || "N/A";
    if (memberSince !== "N/A") {
      memberSince = memberSince.split("T")[0];
    }
    this.memberSince = memberSince;
  }

  getCompanyId() {
    return this.companyId;
  }

  getCompanyName() {
    return this.companyName;
  }

  getAdminId() {
    return this.adminId;
  }

  getAdminName() {
    return this.adminName;
  }

  getEmail() {
    return this.email;
  }

  getPhoneNumber() {
    return this.phoneNumber;
  }

  getCountry() {
    return this.country;
  }

  getCurrentPlan() {
    return this.currentPlan;
  }

  getAdministrativeLevel() {
    return this.administrativeLevel;
  }

  getAdministrativeId() {
    return this.administrativeId;
  }

  getSubRegionId() {
    if (this.administrativeLevel === SUB_REGIONAL) {
      return this.administrativeId;
    }
    return null;
  }

  getRegionId() {
    if (this.administrativeLevel === REGIONAL) {
      return this.administrativeId;
    }
    return null;
  }
}

export class CompanyInfoMap {
  constructor(companies = []) {
    this._companies = [];
    this._byId = {};

    if (!Array.isArray(companies)) {
      return;
    }

    companies.forEach((item) => {
      const company = item instanceof CompanyInfo ? item : new CompanyInfo(item);
      this._companies.push(company);
      this._byId[company.companyId] = company;
    });
  }

  getAccountDetailsByCompanyId(companyId) {
    return this._byId[companyId];
  }

  getAccountsArray() {
    return this._companies;
  }

  getAccountsObj() {
    return this._byId;
  }

  getCompanyIdNamePair() {
    return this._companies.map((account) => ({
      label: account.companyName,
      value: account.companyId,
    }));
  }

  getTotalCountOfActiveAccounts() {
    return this._companies.length;
  }

  getTotalCountOfPaidAccounts(plansList) {
    return this._companies.filter((account) => plansList.isPaid(account.currentPlan)).length;
  }
}
